import type { SlackAsk } from './types';

export const SLACK_ASKS: readonly SlackAsk[] = [
  {
    member: 'Steve Brudzewski',
    memberId: 'steve-brudzewski',
    channel: '#events',
    time: '2 hours ago',
    message: 'Hey everyone — just moved to Miami a few months ago. Anyone know of upcoming meetups or dinners in the area? Would love to connect with members down here.',
    draft: 'Hey Steve! Welcome to Miami. We have a Founders Dinner on March 8 with 14 members confirmed — I\'ll make sure you\'re on the list. I also want to connect you with a few Miami-based members who\'d be great to meet. I\'ll send some intros this week.',
  },
  {
    member: 'Austin Dunbar',
    memberId: 'austin-dunbar',
    channel: '#general',
    time: 'Yesterday',
    message: 'Curious if anyone here has gone through selling a service-based business (agency, consulting, etc). Working on some long-term planning and would appreciate any perspective from people who\'ve actually done it.',
    draft: 'Austin — great question, and yes. I want to connect you with a couple members who\'ve exited service businesses. I\'m also thinking about a few people in your upcoming mastermind group who\'ve navigated this. Let me set up some intros this week.',
  },
  {
    member: 'Maria Santos',
    memberId: 'maria-santos',
    channel: '#growth',
    time: '3 days ago',
    message: 'Looking for recommendations on 3PL partners for CPG. We\'re outgrowing our current fulfillment setup and need something that can handle our subscription model. Anyone have a provider they love?',
    draft: 'Maria — I know at least two members who\'ve scaled CPG with subscription fulfillment. Let me connect you with them directly. One switched 3PLs last year and can share what worked and what didn\'t.',
  },
] as const;
